<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import FileUpload from '../../../../components/ui/form/FileUpload.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  name: props.data?.name || props.listCreateName || "",
    code: props.data?.code || "",
    channel_type: props.data?.channel_type || "",
    icon_image: props.data?.icon_image || "",
    icon_css: props.data?.icon_css || "",
    require_delivery: props.data?.require_delivery || false,
    kot: props.data?.kot || false,
    active: props.data?.active || true,
    uid: props.data?.uid || "",
  });

setFieldRules("name", [required("Name is required")]);
setFieldRules("code", [required("Code is required")]);
setFieldRules("channel_type", [required("Channel Type is required")]);


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})

const channelTypes = [
  { id: "Physical", name: "Physical" },
  { id: "Online", name: "Online" },
];

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          label="Icon Image"
          :max-size="5"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="brands"
          v-model="fields.icon_image.value"
        />
      </div>

      <div class="grid md:grid-cols-3 gap-6">
        <TextInput
          v-model="fields.code.value"
          label="Code"
          :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null"
          @blur="fields.code.touched = true"
        />

        <TextInput
          v-model="fields.name.value"
          label="Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />

        <SearchSelect
          v-model="fields.channel_type.value"
          label="Channel Type"
          :options="channelTypes"
          :readonly="isReadOnly"
          :error="
            fields.channel_type.touched ? fields.channel_type.error : null
          "
          @blur="fields.channel_type.touched = true"
        />

        <TextInput
          v-model="fields.icon_css.value"
          label="Icon CSS"
          :readonly="isReadOnly"
          :error="fields.icon_css.touched ? fields.icon_css.error : null"
          @blur="fields.icon_css.touched = true"
        />

        <CheckInput
          v-model="fields.kot.value"
          :readonly="isReadOnly"
          label="Make KOT"
          :error="fields.kot.touched ? fields.kot.error : null"
          @blur="fields.kot.touched = true"
        />

        <CheckInput
          v-model="fields.require_delivery.value"
          :readonly="isReadOnly"
          label="Create Delivery Trackings"
          :error="fields.require_delivery.touched ? fields.require_delivery.error : null"
          @blur="fields.require_delivery.touched = true"
        />

        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>